import Product from "@core/domain/product/product";
import store from "@/store"
import {getAllSubstanceLists} from "@core/domain/substance";

let organizationId = store.state.user.organization.id;
let products = {};
products[organizationId] = {};

store.watch(
    (state) => {
        return state.user.organization;
    },
    () => {
        organizationId = store.state.user.organization.id;
        if (!products.hasOwnProperty(organizationId)) {
            products[organizationId] = {};
        }
    }
)

export function add(product) {
    products[organizationId][product.id] = product;
}

export function has(id) {
    return products[organizationId][id] instanceof Product;
}

export function clear(id) {
    if (products[organizationId][id]) {
        delete products[organizationId][id];
    }
}

export default (id) => {
    if (has(id)) {
        return products[organizationId][id];
    }
    return products[organizationId][id] = new Product(id, getAllSubstanceLists());
}
